<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="h3">List of Plates</a></h2><a id="h3">
<p class="common"><img alt="images" src="images/common.jpg"/></p>
</a><p class="list1"><a id="h3"></a><span href="#/22_chapter044#plate1" title="Link target outside of Sample">1. Garnet Wolseley. (Taylor Library)</span></p>
<p class="list1"><span href="#/23_chapter045#plate2" title="Link target outside of Sample">2. Field Marshal Sir Evelyn Wood. (Library of Congress)</span></p>
<p class="list1"><span href="#/24_chapter046#plate3" title="Link target outside of Sample">3. Redvers Buller. (Taylor Library)</span></p>
<p class="list1"><span href="#/25_chapter047#plate4" title="Link target outside of Sample">4. Charles Gordon. (Taylor Library)</span></p>
<p class="list1"><span href="#/26_chapter048#plate5" title="Link target outside of Sample">5. George Colley. (The Royal Collection © HM Queen Elizabeth II)</span></p>
<p class="list1"><span href="#/27_chapter049#plate6" title="Link target outside of Sample">6. Caricature of Lord Chelmsford. (Private collection)</span></p>
<p class="list1"><span href="#/28_chapter0410#plate7" title="Link target outside of Sample">7. Lord Chelmsford. (Private collection of Kim Thesiger, 4th Viscount ….. Chelmsford)</span></p>
<p class="list1"><span href="#/29_chapter0411#plate8" title="Link target outside of Sample">8. Frederick Roberts, General the Hon. Sir Arthur Hardinge and General Sir Donald Stewart. (Taylor Library)</span></p>
<p class="list1"><span href="#/30_chapter0412#plate9" title="Link target outside of Sample">9. Frederick Roberts. (Library of Congress)</span></p>
<p class="list2"><span href="#/31_chapter0413#plate10" title="Link target outside of Sample">10. Herbert Kitchener. (Taylor Library)</span></p>
<p class="list2"><span href="#/32_chapter0414#plate11" title="Link target outside of Sample">11. Herbert Kitchener. (The National Army Museum)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_plates.vue?65346038